import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import {
  EventMessage,
  EventPayload,
  EventType,
  AuthenticationResult,
  InteractionStatus,
  RedirectRequest
} from '@azure/msal-browser';
import { CryptoUtils, Logger, UserAgentApplication } from 'msal';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from './../environments/environment.dev';
import {
  PlayerSidenavComponent,
  PlayerSidenavReferencesService
} from './shared';
import { SidenavInterface } from './sidenav/sidenav.interface';
import * as FullStory from '@fullstory/browser';

declare var FS;
declare var ga;
const MSAL_CONFIG = {
  auth: {
    clientId: environment.clientId
  }
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: []
})
export class AppComponent implements OnInit {
  @ViewChild(PlayerSidenavComponent, { static: true })
  playerSidenav: PlayerSidenavComponent;
  isAuthenticated: boolean;
  navLinks: SidenavInterface[];
  loggedIn = false;
  isDarkMode = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private playerSidenavReferencesService: PlayerSidenavReferencesService,
    private router: Router,
    private overlayContainer: OverlayContainer,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (location.hash.includes('id_token')) {
          // this will close MS login popup
          // tslint:disable-next-line: no-unused-expression
          new UserAgentApplication(MSAL_CONFIG);
        }
      }
    });
    const  orgId  = environment.orgId;

    // load the FullStory recording snippet if an orgId is set
    if (orgId) {
      FullStory.init({ orgId, debug: false });
    }
  
  }

  async ngOnInit() {
    if (this.isDarkMode){
      this.overlayContainer.getContainerElement().classList.add('dark-mode');
    }

    this.playerSidenavReferencesService.set('right', this.playerSidenav);

    this.checkoutAccount();

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkoutAccount();
      });

    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result != null) {
          localStorage.setItem('msal.idtoken', result.idToken);
          this.authService.instance.setActiveAccount(result.account);
        }
        this.checkoutAccount();
        this.router.navigate(['/']);
      },
      error: (error) => console.error(error)
    });

    // Get the authentication state for immediate use

    // Full Story integration
    setTimeout(() => {
      if (typeof FS === 'undefined') {
        return;
      } else {
        const userClaims = this.authService.instance.getAllAccounts()[0];
        const isAuthenticated = !!userClaims;
        if (isAuthenticated) {
          try {
            ga('set', 'userId', userClaims.username);
          } catch (e) {}
          try {
            FS.identify(userClaims.idTokenClaims, {
              displayName: userClaims.name,
              email: userClaims.username
            });
          } catch (e) {}
        }
      }
    }, 5000);
  }

  checkoutAccount() {
    this.loggedIn = !!this.authService.instance.getAllAccounts()[0];
  }
}
